import { Field, useForm } from 'react-final-form';
import styles from './DebtSchedule.module.scss';
import MeritoRadioButton from '../../../Finance/components/RadioButton/MeritoRadioButton';
import MeritoButton from '../../../../components/common/MeritoButtons/MeritoButtons';
import { Modal } from 'reactstrap';
import { useState } from 'react';
import DebtScheduleGrid from './DebtScheduleGrid';
import { directorSelectOptionValidation } from '../../Director/directorHelper';
import { ApplicationContextType } from '../../../../interfaces/interfaces';


const DebtSchedule = () => {
    const { getState } = useForm();

    const hasDebt = getState().values?.hasDebt;
    const [isOpenDebtSchedule, setIsOpenDebtSchedule] = useState(false);


    return (
        <>
            <div className={styles.fieldsContainer}>
                <Field name="hasDebt" validate={(values) => directorSelectOptionValidation(values)}>
                    {(props) => (
                        <MeritoRadioButton
                            {...props.input}
                            label="Does your brand have any debt?"
                            radioLabels={[
                                { label: 'Yes', value: 'yes' },
                                { label: 'No', value: 'no' },
                            ]}
                            name={props.input.name}
                            value={props.input.value}
                            onChange={props.input.onChange}
                            error={props.meta.error}
                            touched={props.meta.touched}
                            size="md2"
                        />
                    )}
                </Field>
            </div>

            {hasDebt == 'yes' && (
                <div className={styles.fieldsContainer}>
                    <div className={styles.addDetailsRootContainer}>
                        <div className={styles.leftContainer}>
                            <div className={styles.title}>
                                Debt schedule
                            </div>
                        </div>
                        <div className={styles.rightContainer}>
                            <MeritoButton
                                btnText="Add Details"
                                type='primary-1'
                                size='md'
                                onClick={() => {
                                    setIsOpenDebtSchedule(true)
                                }}
                            />
                        </div>
                    </div>
                    <Field name="debtSchedule">
                        {(props) => (
                            <>
                                {props?.meta?.error && props?.meta?.touched ? <div className={styles.errorContainer}>
                                    {props?.meta?.error}
                                </div> : null}
                            </>
                        )}
                    </Field>
                    <Modal
                        isOpen={isOpenDebtSchedule}
                        toggle={() => {
                            setIsOpenDebtSchedule(!isOpenDebtSchedule)
                        }}
                        size='lg'
                        fullscreen={true}
                        keyboard={false}
                    >
                        <DebtScheduleGrid formType={ApplicationContextType.underwriting} fieldName='debtSchedule' setIsOpen={setIsOpenDebtSchedule} isOpen={isOpenDebtSchedule} />
                    </Modal>
                </div>
            )}

        </>
    );
}

export default DebtSchedule;